/**
 * Iraqi dinar.
 */
export var IQD = {
  code: 'IQD',
  base: 10,
  exponent: 3
};